import React from "react";
import ServicesSection from "../../components/Home/ServiceCard";
import BannerSection from "../../components/common/BannerSection";
import { Banner } from "../../assets/images";
import { ArrowDownward, ArrowDownwardTwoTone, MoveDown } from "@mui/icons-material";
import ServicesSectionAbout from "../../components/Home/ServiceCardAbout";

export default function Services() {
  return (
    <div className="w-full flex flex-col ">
      <BannerSection backgroundImage={Banner} firstWord="خدماتنا" />
      <div className="flex text-2xl mt-32 flex-col w-full items-center gap-12 text-black">
        <div>
          <ArrowDownwardTwoTone fontSize={"large"} className="text-error" />
        </div>
        <div className=" font-bold  max-md:text-center">خدمات تشطيب متكاملة باعلى معاير الجودة </div>
      </div>
      <ServicesSection />
    </div>
  );
}
